function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Union 4",
  d: "M27.335 57.033L1.172 30.87a4 4 0 010-5.656l2.121-2.122a4 4 0 015.657 0l26.163 26.163L83.196 1.172a4 4 0 015.656 0l1.415 1.414a5 5 0 010 7.071L35.113 64.811z",
  fill: "#fff"
});

function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 91.731 64.811",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _ref2);
}

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MS43MzEgNjQuODExIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBpZD0iVW5pb25fNCIgZGF0YS1uYW1lPSJVbmlvbiA0IiBjbGFzcz0iY2xzLTEiIGQ9Ik0yOC45OTIsNTguNjksMi44MjksMzIuNTI3YTQsNCwwLDAsMSwwLTUuNjU2TDQuOTUsMjQuNzQ5YTQsNCwwLDAsMSw1LjY1NywwTDM2Ljc3LDUwLjkxMiw4NC44NTMsMi44MjlhNCw0LDAsMCwxLDUuNjU2LDBsMS40MTUsMS40MTRhNSw1LDAsMCwxLDAsNy4wNzFMMzYuNzcsNjYuNDY4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNjU3IC0xLjY1NykiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };